var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-body-1"},[_vm._v(" Redirecting you to the quiz... ")])}
var staticRenderFns = []

export { render, staticRenderFns }